import { Image, Paragraph } from 'mdast'
import {
  ContainerDirective,
  LeafDirective,
  TextDirective,
} from 'mdast-util-directive'

const processImage = (
  node: TextDirective | LeafDirective | ContainerDirective,
  index: number,
  parent: any
) => {
  const imgPath = node?.attributes?.id

  // Require a `imgPath` attribute, crash otherwise.
  if (typeof imgPath !== 'string') {
    console.error('Expected `imgPath` attribute on image directive', node)
    return
  }

  const img: Image = {
    type: 'image',
    url: imgPath,
    alt: node?.attributes?.alt || undefined,
    title: node?.attributes?.title || undefined,
  }

  const imgHeight: string | undefined = node?.attributes?.['max-height']
  const imgWidth: string | undefined = node?.attributes?.['max-width']

  if (imgHeight !== undefined && imgWidth !== undefined) {
    img.data = img.data ?? {}
    img.data.hProperties = {
      width: imgWidth,
      height: imgHeight,
    }
  }

  // Images cannot be directly in things. They are phrasing content.
  const paragraph: Paragraph = {
    type: 'paragraph',
    children: [img],
  }

  // Replace directive with paragraph.
  parent.children.splice(index, 1, paragraph)
}

export default processImage